// ファイルアイコンコンポーネント

import React from 'react';
import { FileType } from '../types';

interface FileIconProps {
  fileType: FileType;
  className?: string;
}

const FileIcon: React.FC<FileIconProps> = ({ fileType, className = 'w-8 h-8' }) => {
  const getIconConfig = (type: FileType) => {
    switch (type) {
      case 'pdf':
        return {
          color: 'text-red-500',
          path: 'M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z'
        };
      case 'excel':
        return {
          color: 'text-green-600',
          path: 'M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z'
        };
      case 'word':
        return {
          color: 'text-blue-600',
          path: 'M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z'
        };
      case 'ppt':
        return {
          color: 'text-orange-600',
          path: 'M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z'
        };
      case 'image':
        return {
          color: 'text-purple-500',
          path: 'M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z'
        };
      case 'csv':
        return {
          color: 'text-orange-500',
          path: 'M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z'
        };
      default:
        return {
          color: 'text-gray-500',
          path: 'M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z'
        };
    }
  };

  const { color, path } = getIconConfig(fileType);

  return (
    <svg 
      className={`${className} ${color}`} 
      fill="currentColor" 
      viewBox="0 0 20 20" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fillRule="evenodd" d={path} clipRule="evenodd" />
    </svg>
  );
};

export default FileIcon;
